module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="members-filters-region"></div>\n<div id="members-region"></div>';
}
return __p;
};
